export default __webpack_public_path__ + "static/ma-logo-1-87e07e80b9c0daded883d3e96f1c636c.png";